import usePagedLeaderboard from "../hooks/usePagedLeaderboard";
import useLeaderboardOrdinationStore from "../store/leaderboardOrdinatinoStore";
import LeaderboardListItem from "./LeaderboardListItem";
import LeaderboardSelector from "./LeaderboardSelector";
import "./ListUserPaged.css";

interface LeaderboardListProps {
  communityId?: number;
  title?: string;
  emptyMessage?: string;
}

const LeaderboardList = ({
  communityId,
  title = "LEADERBOARD",
  emptyMessage = "No player found for this medal.",
}: LeaderboardListProps) => {
  const page = useLeaderboardOrdinationStore((state) => state.page);
  const pageSize = useLeaderboardOrdinationStore((state) => state.pageSize);
  const name = useLeaderboardOrdinationStore((state) => state.name);
  const setName = useLeaderboardOrdinationStore((state) => state.setName);
  const setPage = useLeaderboardOrdinationStore((state) => state.setPage);
  const fieldOrder = useLeaderboardOrdinationStore((state) => state.fieldOrder);
  const currentOrder = useLeaderboardOrdinationStore(
    (state) => state.currentOrder,
  );

  const { data, isLoading, error } = usePagedLeaderboard({
    pageSize,
    page,
    name,
    fieldOrder,
    currentOrder,
    communityId,
  });

  if (isLoading) return <div className="user-list-container">Loading...</div>;
  if (error)
    return <div className="user-list-container">Error: {error.message}</div>;

  const validPlayers =
    data?.items.filter(
      (player) => player.userMedal && player.userMedal.quantity > 0,
    ) || [];

  return (
    <div className="user-list-container">
      <div className="user-list-header">
        <h2>{title}</h2>
        <LeaderboardSelector />
        <div className="search-input-container">
          <input
            type="text"
            placeholder="Search by name..."
            value={name}
            onChange={(e) => {
              setName(e.target.value);
              setPage(0);
            }}
          />
        </div>
      </div>
      <div className="leaderboard-preview">
        <div className="preview-entries">
          {validPlayers.length === 0 ? (
            <div
              style={{ textAlign: "center", color: "white", padding: "20px" }}
            >
              {emptyMessage}
            </div>
          ) : (
            validPlayers.map((player, index) => (
              <LeaderboardListItem
                categoryName={fieldOrder}
                key={`${fieldOrder}-${player.user.id}`}
                player={player}
                rank={page * pageSize + index + 1}
              />
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default LeaderboardList;
